const cestMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/];

export default cestMask;
